import React from 'react';
import { Link } from 'react-router-dom';

import { Container } from './styles';

function IconList({ title, items = [] }) {
  return (
    <Container>
      <h5 className="title">{title}</h5>

      <ul className="items">
        {items.map(item => (
          <li key={item.title} className="item">
            <Link
              className="item__link"
              to={process.env.PUBLIC_URL + '/' + item.to}
            >
              {item.icon && (
                <div className="item__icon">
                  <item.icon />
                </div>
              )}

              <div className="item__title">
                {item.title}
                {item.description && (
                  <small className="item__description">
                    {item.description}
                  </small>
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </Container>
  );
}

export default IconList;
